import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Badge } from 'react-bootstrap';
import './PortfolioGrid.css';
import viedo2 from "../../assets/viedo2.png"
import tarteebsystem from "../../assets/tarteebsystem.png"
import video1PNG from "../../assets/video1PNG.png"
import video3 from "../../assets/video3.png"
import afaq from "../../assets/afaq.png"
import afaqsystem from "../../assets/afaqsystem.png"
import AIProject from "../../assets/AIProject.png"
import outlow from "../../assets/outlow.png"
import HeavenSmile from "../../assets/HeavenSmile.png"
import ArabOpenUniversity from "../../assets/ArabOpenUniversity.png"
import baa from "../../assets/baa.jpeg"
import Osta from "../../assets/baa.jpeg"
import bluenilehighlights from "../../assets/bluenilehighlights.png"
import Police from "../../assets/Police.png"
import resturant from "../../assets/resturant.png"
import { useSelector } from 'react-redux';

function PortfolioGrid() {
      const { currentLocal } = useSelector((state) => state.currentLocal);
const [filter, setFilter] = useState(currentLocal.general.allProjects);
    const categories = [currentLocal.general.allProjects, currentLocal.general.aiProjects, currentLocal.general.webInfrastructure, currentLocal.general.mobile, currentLocal.general.systems, currentLocal.general.interactiveVideos];
const projects = [
  {
    id: 1,
    title: "Tokyo",
    description: currentLocal.general.videoDesc,
    category: currentLocal.general.interactiveVideos,
    type: "square",
    image: video1PNG,
    badge: currentLocal.general.interactiveVideos,
    link: "https://viedoes.vercel.app/"
  },
  {
    id: 2,
    title: "Poor",
    description: currentLocal.general.videoDesc,
    category: currentLocal.general.interactiveVideos,
    type: "square",
    image: viedo2,
    badge: currentLocal.general.interactiveVideos,
    link: "https://viedoes.vercel.app/video2"
  },
  {
    id: 3,
    title: "Industrial Revolution",
    description: currentLocal.general.videoDesc,
    category: currentLocal.general.interactiveVideos,
    type: "square",
    image: video3,
    badge: currentLocal.general.interactiveVideos,
    link: "https://viedoes.vercel.app/video3"
  },
  {
    id: 4,
    title: "Tarteeb System",
    description: currentLocal.general.attendanceSystemDesc,
    category: currentLocal.general.systems,
    type: "square",
    badge: currentLocal.general.systems,
    image: tarteebsystem,
    tech: ["React.js", "PHP"],
    link: "https://taarteb.com/"
  },
  {
    id: 5,
    title: "afaq System",
    description: currentLocal.general.attendanceSystemDesc,
    category: currentLocal.general.systems,
    type: "square",
    badge: currentLocal.general.systems,
    image: afaq,
    tech: ["React.js", "PHP"],
    link: "https://alaafaqschool.com/"
  },
  {
    id: 6,
    title: "muhadarati System",
    description: currentLocal.general.attendanceSystemDesc,
    category: currentLocal.general.systems,
    type: "square",
    badge: currentLocal.general.systems,
    image: afaqsystem,
    tech: ["React.js", "PHP"],
    link: "https://muhadarati.vercel.app/"
  },
  {
    id: 7,
    title: "resturant System",
    description: currentLocal.general.restaurantSystemDesc,
    category: currentLocal.general.systems,
    type: "square",
    badge: currentLocal.general.systems,
    image: resturant,
    tech: ["React.js", "PHP"],
    link: "https://muhadarati.vercel.app/"
  },
  {
    id: 8,
    title: "Police academy",
    description: currentLocal.general.policeAcademyDesc,
    category: currentLocal.general.webInfrastructure,
    type: "square",
    badge: currentLocal.general.webInfrastructure,
    image: Police,
    tech: ["React.js", "PHP"],
    link: "https://mysaif.net/"
  },
  {
    id: 9,
    title: "academy",
    description: currentLocal.general.aiAcademyDesc,
    category: currentLocal.general.aiProjects,
    type: "square",
    badge: currentLocal.general.aiProjects,
    image: AIProject,
    tech: ["React.js", "PHP"],
    link: "https://oman-courses.vercel.app/"
  },
  {
    id: 10,
    title: "Arab Open University",
    description: currentLocal.general.universityDesc,
    category: currentLocal.general.webInfrastructure,
    type: "square",
    badge: currentLocal.general.webInfrastructure,
    image: ArabOpenUniversity,
    tech: ["React.js", "PHP"],
    link: "https://aou-umber.vercel.app/"
  },
  {
    id: 11,
    title: "outlow",
    description: currentLocal.general.storeDesc,
    category: currentLocal.general.webInfrastructure,
    type: "square",
    badge: currentLocal.general.webInfrastructure,
    image: outlow,
    tech: ["React.js", "PHP"],
    link: "https://outlawbrand.shop/"
  },
  {
    id: 12,
    title: "blue-nile-highlights",
    description: currentLocal.general.realEstateDesc,
    category: currentLocal.general.webInfrastructure,
    type: "square",
    badge: currentLocal.general.webInfrastructure,
    image: bluenilehighlights,
    tech: ["React.js", "PHP"],
    link: "https://blue-nile-highlights-vbt1.vercel.app/"
  },
  {
    id: 13,
    title: "HeavenSmile",
    description: currentLocal.general.storeDesc,
    category: currentLocal.general.webInfrastructure,
    type: "square",
    badge: currentLocal.general.webInfrastructure,
    image: HeavenSmile,
    tech: ["React.js", "PHP"],
    link: "https://smileheavenglow.com/"
  },
  {
    id: 14,
    title: "baa",
    description: currentLocal.general.marriageAppDesc,
    category: currentLocal.general.mobile,
    type: "square",
    badge: currentLocal.general.mobile,
    image: baa,
    tech: ["React.js", "PHP"],
    link: ""
  }
];
useEffect(() => {
setFilter(currentLocal.general.allProjects)
}, [currentLocal])
const filteredProjects = filter === currentLocal.general.allProjects
    ? projects 
    : projects.filter((project) =>project?.category?.toLowerCase().trim() === filter?.toLowerCase().trim());
    console.log("FILTER:", filter);
console.log("PROJECTS:", projects.map(p => p.category));
console.log("RENDER COUNT:", filteredProjects.length);
  return (
    <section className="portfolio-section py-5">
            <Container>
        {/* Filter Tabs */}
<div className="tabs-container d-flex gap-2 mb-5">
            {categories.map(cat => (
            <Button 
              key={cat}
              className={`filter-btn ${filter === cat ? 'active' : ''}`}
              onClick={() => setFilter(cat)}
            >
              {cat}
            </Button>
          ))}
        </div>
        {filter ==currentLocal.general.allProjects && <div className="text-center mb-4">
          {/* <h5 className="display-5 fw-bold text-muted">{currentLocal.general.allProjects}</h5> */}
          <p className="text-muted">{currentLocal.general.allProjectsText}</p>
<Row>
  {projects.map((project,index) => (
        <Col md={4} key={project.id} className='mt-5'>
          <div className="bento-card p-4">
              <div className="card-img-placeholder mb-4">
              <img src={project.image}className='w-100 h-100'/>
            </div>
            {/* <div className="mobile-img-placeholder mb-4"></div> */}
            <Badge className="tech-badge mb-2">
              {project.badge}
            </Badge>
            <h4>      #{index + 1} - {project.title}
</h4>
            <p className="small text-muted">{project.description}</p>
            <a href={project?.link} className="view-link"target='_blank'>{currentLocal.general.view} →</a>

          </div>
        </Col>

  ))}
</Row>

        </div>}
        {filter ==currentLocal.general.aiProjects && <div className="text-center mb-4">
          {/* <h5 className="display-5 fw-bold text-muted">{currentLocal.general.aiProjects}</h5> */}
          <p className="text-muted">{currentLocal.general.aiProjectsText}</p>
          <Row>
            {projects.filter(p => p?.category?.toLowerCase().trim() === currentLocal.general.aiProjects?.toLowerCase().trim()).map((project,index) => (
                  <Col md={4} key={project.id}>
                    <div className="bento-card p-4">
                        <div className="card-img-placeholder mb-4">
                        <img src={project.image}className='w-100 h-100'/>
                      </div>
                      {/* <div className="mobile-img-placeholder mb-4"></div> */}
                      <Badge className="tech-badge mb-2">
                        {project.badge}
                      </Badge>
                      <h4>      #{index + 1} - {project.title}
    </h4>
                      <p className="small text-muted">{project.description}</p>
                      <a href={project?.link} className="view-link"target='_blank'>{currentLocal.general.view} →</a>
                    </div>
                  </Col>
            ))}
            </Row>
        </div>}
        {filter ==currentLocal.general.webInfrastructure && <div className="text-center mb-4">
          {/* <h5 className="display-5 fw-bold text-muted">{currentLocal.general.webInfrastructure}</h5> */}
          <p className="text-muted">{currentLocal.general.webInfrastructureText}</p>
          <Row>
            {projects.filter(p => p.category?.toLowerCase().trim() === currentLocal.general.webInfrastructure?.toLowerCase().trim()).map((project,index) => (
                  <Col md={4} key={project.id}>
                    <div className="bento-card p-4">
                        <div className="card-img-placeholder mb-4">
                        <img src={project.image}className='w-100 h-100'/>
                      </div>
                      {/* <div className="mobile-img-placeholder mb-4"></div> */}
                      <Badge className="tech-badge mb-2">
                        {project.badge}
                      </Badge>
                      <h4>      #{index + 1} - {project.title}
    </h4>
                      <p className="small text-muted">{project.description}</p>
                      <a href={project?.link} className="view-link"target='_blank'>{currentLocal.general.view} →</a>
                    </div>
                  </Col>
            ))}

          </Row>
        </div>}
        {filter ==currentLocal.general.mobile && <div className="text-center mb-4">
            {/* <h5 className="display-5 fw-bold text-muted">{currentLocal.general.mobile}</h5> */}
          <p className="text-muted">{currentLocal.general.mobileText}</p>
          <Row>
            {projects.filter(p => p.category?.toLowerCase().trim() === currentLocal.general.mobile?.toLowerCase().trim()).map((project,index) => (
                  <Col md={4} key={project.id}>
                    <div className="bento-card p-4">
                        <div className="card-img-placeholder mb-4">
                        <img src={project.image}className='w-100 h-100'/>
                      </div>
                      {/* <div className="mobile-img-placeholder mb-4"></div> */}
                      <Badge className="tech-badge mb-2">
                        {project.badge}
                      </Badge>
                      <h4>      #{index + 1} - {project.title}
    </h4>
                      <p className="small text-muted">{project.description}</p>
                      <a href={project?.link} className="view-link"target='_blank'>{currentLocal.general.view} →</a>
                    </div>
                  </Col>
            ))}

          </Row>
        </div>}
        {filter ==currentLocal.general.systems && <div className="text-center mb-4">
          {/* <h2 className="display-5 fw-bold">{currentLocal.general.systems}</h2> */}
          <p className="text-muted">{currentLocal.general.systemsText}</p>
          <Row>
            {projects.filter(p => p.category?.toLowerCase().trim() === currentLocal.general.systems?.toLowerCase().trim()).map((project,index) => (
                  <Col md={4} key={project.id}>
                    <div className="bento-card p-4">
                        <div className="card-img-placeholder mb-4">
                        <img src={project.image}className='w-100 h-100'/>
                      </div>
                      {/* <div className="mobile-img-placeholder mb-4"></div> */}
                      <Badge className="tech-badge mb-2">
                        {project.badge}
                      </Badge>
                      <h4>      #{index + 1} - {project.title}
    </h4>
                      <p className="small text-muted">{project.description}</p>
                      <a href={project?.link} className="view-link"target='_blank'>{currentLocal.general.view} →</a>
                    </div>
                  </Col>
            ))}

          </Row>
        </div>}
        {filter ==currentLocal.general.interactiveVideos && <div className="text-center mb-4">
          {/* <h2 className="display-5 fw-bold">{currentLocal.general.interactiveVideos}</h2> */}
          <p className="text-muted">{currentLocal.general.interactiveVideosText}</p>
          <Row>
            {projects.filter(p => p.category?.toLowerCase().trim() === currentLocal.general.interactiveVideos?.toLowerCase().trim()).map((project,index) => (
            <Col md={4} key={project.id}>
              <div className="bento-card p-4">
                  <div className="card-img-placeholder mb-4">
                  <img src={project.image}className='w-100 h-100'/>
                </div>
                {/* <div className="mobile-img-placeholder mb-4"></div> */}
                <Badge className="tech-badge mb-2">
                  {project.badge}
                </Badge>
                <h4>      #{index + 1} - {project.title}
</h4>
                <p className="small text-muted">{project.description}</p>
                <a href={project?.link} className="view-link"target='_blank'>{currentLocal.general.view} →</a>
              </div>
            </Col>
            ))}

          </Row>
        </div>}
      </Container>
    </section>
  )
}

export default PortfolioGrid
